export default "__VITE_ASSET__4IHSlvhn__"